import {Observable, of} from 'rxjs';
import Filters from '@/library/filter/filters';
import Filter from '@/library/filter/filter.interface';
import LayerVisibility from '@/interfaces/geo/layer-visibility.interface';

export default class MapLayersService {
    private static instance: MapLayersService;
    private routeLayers: string[] = [
        'routeLayer',
        'otherlayer',
        'routePointsLayer',
        'routeTrackLayer',
    ];
    private objectLayers: string[] = [
        'infra',
        'clusterLayer',
    ]
    private gameLayers: string[] = [
        'GameMainPoint',
        'GameCheckPoint',
        'GameTrack',
    ];

    private constructor() {
    }

    public static getInstance(): MapLayersService {
        if (!MapLayersService.instance) {
            MapLayersService.instance = new MapLayersService();
        }
        return MapLayersService.instance;
    }

    public layerVisibilities(filters: Filters): Observable<LayerVisibility[]> {
        let objectLayersVisibility = true;
        const objectVisibilities = this.objectLayers.map((layerId: string) => {
            return {layerId: layerId, visibility: objectLayersVisibility} as LayerVisibility;
        });
        return of(objectVisibilities);
    }

    public gameLayerVisibilities(): LayerVisibility[] {
        const routeVisibilities = this.routeLayers.map((layerId: string) => {
            return {layerId: layerId, visibility: false} as LayerVisibility;
        });
        const objectVisibilities = this.objectLayers.map((layerId: string) => {
            return {layerId: layerId, visibility: false} as LayerVisibility;
        });
        const gameVisibilities = this.gameLayers.map((layerId: string) => {
            return {layerId: layerId, visibility: true} as LayerVisibility;
        });
        return [...routeVisibilities, ...objectVisibilities, ...gameVisibilities];
    }
}
